import { Link } from "react-router-dom";

const steps = [
  {
    number: "01",
    icon: "ri-file-list-3-line",
    title: "Share Your Situation",
    text: "Tell us about your vehicle, loan status, monthly payment, and goals through a short form or a quick call with our team.",
  },
  {
    number: "02",
    icon: "ri-search-eye-line",
    title: "Get a Case Review",
    text: "Our team reviews your situation and identifies practical, legal options based on your lender, vehicle condition, and timeline.",
  },
  {
    number: "03",
    icon: "ri-roadmap-line",
    title: "Choose the Best Next Step",
    text: "We help coordinate the next action — whether that is transfer support, buyer matching, or an alternative path forward.",
  },
];

const gradientStyle = {
  background: "linear-gradient(135deg, #4F7CFF 0%, #7B8CFF 100%)",
};
const gradientHover = {
  background: "linear-gradient(135deg, #3D6AE8 0%, #6B7CE8 100%)",
};

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 lg:py-28" style={{ backgroundColor: "#FFFFFF" }}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="text-sm font-semibold uppercase tracking-widest"
            style={{ color: "#4F7CFF" }}
          >
            The Process
          </p>
          <h2
            className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl"
            style={{ color: "#1E293B" }}
          >
            How It Works
          </h2>
          <p className="mt-4 text-base leading-7" style={{ color: "#475569" }}>
            Three straightforward steps to find a way forward — no jargon, no
            pressure, just clarity.
          </p>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {steps.map((step, i) => (
            <div
              key={i}
              className="relative rounded-xl p-8"
              style={{
                backgroundColor: "#F8FAFC",
                border: "1px solid #E8EEFF",
              }}
            >
              <div className="mb-5 flex items-center gap-4">
                <div
                  className="flex h-11 w-11 items-center justify-center rounded-lg"
                  style={{ backgroundColor: "#EBF0FF" }}
                >
                  <i
                    className={`${step.icon} text-xl`}
                    style={{ color: "#4F7CFF" }}
                  />
                </div>
                <span
                  className="text-4xl font-black select-none"
                  style={{ color: "#DDEAFF" }}
                >
                  {step.number}
                </span>
              </div>
              <h3 className="mb-3 text-base font-bold" style={{ color: "#1E293B" }}>
                {step.title}
              </h3>
              <p className="text-sm leading-7" style={{ color: "#475569" }}>
                {step.text}
              </p>

              {i < steps.length - 1 && (
                <div
                  className="absolute -right-3 top-1/2 z-10 hidden -translate-y-1/2 lg:flex h-6 w-6 items-center justify-center rounded-full"
                  style={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DDEAFF",
                  }}
                >
                  <i
                    className="ri-arrow-right-line text-xs"
                    style={{ color: "#7B8CFF" }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/intake"
            className="whitespace-nowrap inline-block rounded-lg px-8 py-3.5 text-sm font-semibold text-white transition cursor-pointer"
            style={gradientStyle}
            onMouseEnter={(e) =>
              Object.assign((e.target as HTMLElement).style, gradientHover)
            }
            onMouseLeave={(e) =>
              Object.assign((e.target as HTMLElement).style, gradientStyle)
            }
          >
            Start with a Free Review
          </Link>
        </div>
      </div>
    </section>
  );
}
